/**
 * Gallery Filter Modal Alpine Component
 */
export function galleryFilterComponent() {
  return {
    filter_modal_open: false,
    is_ready: false,
    is_loading: false,

    init() {
      this.filter_modal_open = this.$store.galleryUI.filter_modal_open;
      this.is_loading = this.$store.galleryUI.loading;

      this.$watch(() => this.$store.galleryUI.filter_modal_open, (isOpen) => {
        this.filter_modal_open = isOpen;

        if (isOpen) {
          this.is_ready = true;
          this.$store.galleryUI.lockPanel();

          this.$nextTick(() => {
            const boostOverlay = document.querySelector('.boost-sd__filter-tree-vertical-sticky-overlay');
            if (boostOverlay) {
              boostOverlay.addEventListener('click', (e) => {
                if (e.target === boostOverlay) {
                  this.close();
                }
              });
            }
          });
        } else {
          this.$store.galleryUI.unlockPanel();
        }
      });

      this.$watch(() => this.$store.galleryUI.loading, (loading) => {
        this.is_loading = loading;
      });
    },

    close() {
      this.$store.galleryUI.filter_modal_open = false;
    },

    clearAll() {
      window.galleryBoostBridge?.clearAllFilters();
    },

    applyFilters() {
      window.galleryBoostBridge?.handleApplyButtonClick({ skipLoadingScreen: true });
    },

    get totalActiveFilters() {
      return window.galleryBoostBridge?.filterController?.getFilterCountExcludingOrientation?.() ?? 0;
    }
  };
}
